var React = require('react');

function BreathMainSliderNextBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5692 9.85312C23.0404 9.38196 23.0404 8.61805 22.5692 8.14688L14.8911 0.46883C14.42 -0.00233333 13.6561 -0.0023334 13.1849 0.46883C12.7137 0.939993 12.7137 1.7039 13.1849 2.17506L20.0098 9L13.1849 15.8249C12.7137 16.2961 12.7137 17.06 13.1849 17.5312C13.6561 18.0023 14.42 18.0023 14.8911 17.5312L22.5692 9.85312ZM-0.000732527 10.2065L21.7161 10.2065L21.7161 7.79351L-0.000732316 7.79351L-0.000732527 10.2065Z","fill":"black"}));
}

BreathMainSliderNextBtn.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18","fill":"none"};

module.exports = BreathMainSliderNextBtn;

BreathMainSliderNextBtn.default = BreathMainSliderNextBtn;
